import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {TestimonialsComponent} from './testimonials.component';
import {AddTestimonialComponent} from './add-testimonial/add-testimonial.component';

const routes: Routes = [
  {
    path: 'testimonials',
    component: TestimonialsComponent,
    data: {animation: 'testimonials'}
  },
  {
    path: 'add-testimonial/add',
    component: AddTestimonialComponent,
    data: {animation: 'add-testimonial/add'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestimonialsRoutingModule { }
